import * as React from 'react';
import { RangeInput } from '../../../RangeInput';

import * as styles from './index.css';

export interface IAreaFilterProps {
  areaFrom?: number;
  areaTo?: number;
  onChange(min: number | undefined, max: number | undefined): void;
}

export const AreaFilter = ({ areaFrom, areaTo, onChange }: IAreaFilterProps) => {
  return (
    <div className={styles['container']}>
      <RangeInput spliced maxWidth={120} min={0} max={9999} valueMin={areaFrom} valueMax={areaTo} onChange={onChange} />
      <span className={styles['units']}>
        м<sup>2</sup>
      </span>
    </div>
  );
};
